interface EventDetailsSectionProps {
  eventName: string
  startDate: string
  endDate: string
  themeColor?: string
  logoUrl?: string
  allowPublicRegistration: boolean
  allowAttendeeAppAccess: boolean
  clientName: string
}

export function EventDetailsSection({
  eventName,
  startDate,
  endDate,
  themeColor = 'Red',
  logoUrl,
  allowPublicRegistration,
  allowAttendeeAppAccess,
  clientName,
}: EventDetailsSectionProps) {
  return (
    <div className="bg-white border border-[#f0f0f0] mb-6">
      <div className="p-6">
        <h3 className="text-[15px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[25px] mb-6">
          Event Details
        </h3>

        <div className="flex flex-col gap-5">
          <div className="flex">
            <div className="w-[200px] text-[13px] font-normal text-[rgba(0,0,0,0.65)] font-['Roboto'] leading-[22px]">
              Event Name:
            </div>
            <div className="text-[13px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[22px]">
              {eventName}
            </div>
          </div>
          <div className="flex">
            <div className="w-[200px] text-[13px] font-normal text-[rgba(0,0,0,0.65)] font-['Roboto'] leading-[22px]">
              Event Dates:
            </div>
            <div className="text-[13px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[22px]">
              {startDate} - {endDate}
            </div>
          </div>
          <div className="flex">
            <div className="w-[200px] text-[13px] font-normal text-[rgba(0,0,0,0.65)] font-['Roboto'] leading-[22px]">
              Theme Colour:
            </div>
            <div className="text-[13px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[22px]">
              {themeColor}
            </div>
          </div>
          <div className="flex">
            <div className="w-[200px] text-[13px] font-normal text-[rgba(0,0,0,0.65)] font-['Roboto'] leading-[22px]">
              Allow Public Registration:
            </div>
            <div className="text-[13px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[22px]">
              {allowPublicRegistration ? 'Yes' : 'No'}
            </div>
          </div>
          <div className="flex">
            <div className="w-[200px] text-[13px] font-normal text-[rgba(0,0,0,0.65)] font-['Roboto'] leading-[22px]">
              Allow Attendee App Access:
            </div>
            <div className="text-[13px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[22px]">
              {allowAttendeeAppAccess ? 'Yes' : 'No'}
            </div>
          </div>
          <div className="flex">
            <div className="w-[200px] text-[13px] font-normal text-[rgba(0,0,0,0.65)] font-['Roboto'] leading-[22px]">
              Client Name:
            </div>
            <div className="text-[13px] font-normal text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-[22px]">
              {clientName}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
